// Environments where auth flows stay inside the app (internal /login page,
// logout to the app root) instead of going through the mandator portal.
const INTERNAL_AUTH_ENVIRONMENTS = ["development", "mock", "preview"];

export const USE_INTERNAL_AUTH = INTERNAL_AUTH_ENVIRONMENTS.includes(
  import.meta.env.VITE_APP_ENVIRONMENT ?? ""
);
